import { useEffect, useState } from "react";
import "./SelectCheckboxList.scss";
import { OptionWCheckboxList } from "../../helpers/helpers";

export interface OnChangeStateHandlerProps {
    currentId: number | string;
    currentState: boolean;
}

interface Props {
    label: string;
    options: OptionWCheckboxList | undefined;
    onChange: ({ currentId, currentState }: OnChangeStateHandlerProps) => void;
    name: string;
    countSelected: number;
    placeholder: string;
    readOnly?: boolean;
}

const SelectCheckboxList = ({
    options = [],
    onChange,
    label,
    countSelected,
    placeholder,
    readOnly
}: Props) => {
    const [filterText, setFilterText] = useState("");
    const [optionsSelect, setOptionsSelect] = useState(options);

    useEffect(() => {
        const filteredOptions = options.filter((option) =>
            option.name.toUpperCase().includes(filterText.toUpperCase())
        );
        setOptionsSelect(filteredOptions);
    }, [filterText, options]);

    return (
        <div className="form_control">
            <label className="label">{label}</label>
            <div className="select_checkbox_list">
                <div className="select_checkbox_list__caption unSelectable">
                    <input
                        value={filterText}
                        type="text"
                        className="form_control__input"
                        placeholder={placeholder}
                        onChange={(e) => {
                            e.preventDefault();
                            setFilterText(e.target.value);
                        }}
                    />
                    <div className="select_checkbox_list__caption_counter">
                        {countSelected + "/" + options.length}
                    </div>
                </div>


                <div className="select_checkbox_list__popup" >
                    <div className="select_checkbox_list__popup_container">
                        {optionsSelect.map((option, id) => (
                            <li
                                read-only={String(readOnly)}
                                className={`select_checkbox_list__option ${option.checked ? "selected" : ""}`}
                                key={option.id}
                                onClick={() => {
                                    if (!readOnly) {
                                        return onChange({
                                            currentId: option.id,
                                            currentState: option.checked,
                                        })
                                    }
                                }}
                            >
                                <div className="select_checkbox_list__option_content">
                                    <div className="select_checkbox_list__option_label">
                                        {option.name}
                                    </div>
                                    <input
                                        id={String(id)}
                                        className="select_checkbox_list__option_checkbox"
                                        checked={option.checked}
                                        name="optionState"
                                        type="checkbox"
                                        value={String(option.checked)}
                                        onChange={() => { }}
                                    />
                                </div>
                            </li>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectCheckboxList;
